/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="96.07"
        height="85.27"
        viewBox="0 0 96.07 85.27"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M1.49 0a1.51 1.51 0 0 1 1.49 1.41v80.88H83.7a1.51 1.51 0 0 1 1.5 1.35v.15a1.5 1.5 0 0 1-1.35 1.49H1.49A1.52 1.52 0 0 1 0 83.91V1.5A1.5 1.5 0 0 1 1.49 0Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M94.57 8.41a1.53 1.53 0 0 1 1.5 1.37v16.91a1.502 1.502 0 1 1-3 .15V11.41H77.51a1.48 1.48 0 0 1-1.49-1.34v-.16a1.51 1.51 0 0 1 1.36-1.49h17.19Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M93.51 8.89a1.5 1.5 0 0 1 2.23 2l-.1.11L58.3 48.53l-14-13.89-29.4 29.57a1.5 1.5 0 0 1-2 .11l-.12-.1a1.5 1.5 0 0 1-.1-2l.1-.11 31.52-31.7 14 13.89Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'LineGraphUpwardsTrendIcon';

export default Icon;
